



import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Injectable, Container } from 'ca-middleware';
import MapResolver from '../../util/MapResolver';
import SwitchMap from '@/views/switchMap/SwitchMap.vue';
import publishObjectPath from '@/util/configRegistry';
@Component({
  name: 'LayoutSwitchMap',
  components: {
    SwitchMap,
  },
  mixins: [MapResolver],
})
export default class LayoutSwitchMap extends Vue {
  @Injectable() public container!: Container;

  private datas: any = [];
  constructor() {
    super();
  }
  private mapItemClick(ele: any) {
    this.layerChange({ item: ele });
  }

  private layerChange(options: any) {
    (this as any).resolveMap('map').then((data: any) => {
      const mapShare = this.container.resolve('mapShare');
      const mapWrapper = mapShare.getMapWapper();
      if (options.item.dimension && options.item.dimension === '3d') {
        mapWrapper.setBaseLayer(options.item);
        mapWrapper.switchDimension('3d');

      } else {
        mapWrapper.setBaseLayer(options.item);
        mapWrapper.switchDimension('2d');

      }
      const notify = this.container.resolve('notify');
      notify.emit(`dimension-changed`, options.item.dimension);
    });
  }

  // /**
  //  * @param options
  //  * @param options.map
  //  * @param options.baseLayers
  //  */
  // public init(options: any) {
  //     this.modeData = options.baseLayers;
  //     this.curMode = this.modeData[0];
  //     this.initMap(options.map);
  // }
  private async created() {
    (this as any).resolveMap('map').then((data: any) => {
      const mapShare = this.container.resolve('mapShare');
      const mapConfig = mapShare.getMapConfig();
      this.datas = mapConfig.SwitchLayers;
    });
  }

  /*    private getComponent(moduleName: string = "RoutePlan",componentName: string = "routePlanning") {
        const p = new Promise((resolve,reject)=>{
            (this as any).resolveMap("map").then((data: any) => {
                const temp: any = this;
                const facotory = temp.container.resolve('mapShare').comFactory;
                const component = facotory.getComponent(moduleName,componentName);
                resolve(component);
            }).catch(()=>{ reject('获取地图组件失败') })
        });
        return p;
    }*/
}
